export default "__VITE_ASSET__cddaf527__"